import { TbMenu2 } from "react-icons/tb";
import ProfileDrawer from "./ProfileDrawer";
import NotificationBell from "./NotificationBell";
import { useAuth } from "../AuthProvider";

const Header = ({ toggleSidebar }) => {
  const { user } = useAuth();

  return (
    <div className="bg-[#1c1b19] sticky top-0 z-40 border-b border-zinc-500 shadow-md shadow-black/[0.02]">
      <div className="max-w-screen-2xl mx-auto flex justify-between items-center py-2.5 px-4">
        <button className="text-white sm:hidden" onClick={toggleSidebar}>
          <TbMenu2 size={24} />
        </button>
        <div className="flex w-full items-center justify-end space-x-4">
          <NotificationBell user={user} />

          <p className="text-sm w-[10rem] text-right font-medium text-white">
            Welcome, {user?.first_name} {user?.last_name}
          </p>
          <ProfileDrawer />
        </div>
      </div>
    </div>
  );
};

export default Header;
